// Style
import style from "./module-image.module.scss";

export default function ModuleImage({
  image,
  link = {},
  overlay = {},
  text = {},
  heightPercentage = "67%",
  fit = "cover",
}) {
  if (image === null) {
    return;
  }

  // -- TODO:
  //    - Link
  //    - Overlay Image
  //    - Overlay Text

  // Variables
  const imageItem = image.node;
  let imageStyling = fit === "cover" ? { paddingTop: heightPercentage } : {};

  return (
    <figure className="moduleImageContainer">
      <div className={style.moduleImageObject} fit={fit} style={imageStyling}>
        <img src={imageItem.sourceUrl} alt={imageItem.alt} decoding="async" />
      </div>
      {imageItem.caption && (
        <figcaption dangerouslySetInnerHTML={{ __html: imageItem.caption }} />
      )}
    </figure>
  );
}
